module.exports = __webpack_public_path__ + "assets/img/header-bg.900069b9.png";